'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _package = { version: '1.7.8' };

var _package2 = _interopRequireDefault(_package);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _package2['default'].version;